import type { Particle, Vec2 } from '@/types'
import { copy, scale, add, sub } from './vector'

export function createParticle(
    position: Vec2,
    mass: number,
    radius: number,
    pinned: boolean,
): Particle {
    return {
        position: copy(position),
        previousPosition: copy(position),
        acceleration: { x: 0, y: 0 },
        mass,
        pinned,
        radius,
    }
}

export function verletIntegrate(
    particles: Particle[],
    dt: number,
    damping: number,
): void {
    for (const p of particles) {
        if (p.pinned) continue

        const velocity = sub(p.position, p.previousPosition)
        const dampedVelocity = scale(velocity, damping)

        const newPosition = add(
            add(p.position, dampedVelocity),
            scale(p.acceleration, dt * dt),
        )

        p.previousPosition = copy(p.position)
        p.position = newPosition
        p.acceleration = { x: 0, y: 0 }
    }
}

export function applyGravity(particles: Particle[], gravity: number): void {
    for (const p of particles) {
        if (p.pinned) continue
        p.acceleration = add(p.acceleration, { x: 0, y: gravity })
    }
}

export function clampVelocity(particles: Particle[], maxSpeed: number): void {
    for (const p of particles) {
        if (p.pinned) continue
        const velocity = sub(p.position, p.previousPosition)
        const speed = Math.sqrt(velocity.x * velocity.x + velocity.y * velocity.y)
        if (speed > maxSpeed) {
            const ratio = maxSpeed / speed
            p.previousPosition = sub(p.position, scale(velocity, ratio))
        }
    }
}
